import { Route, ServiceBikeCondition, populateRoute } from "@repo/common"
import { queryOptions } from "@tanstack/react-query"
import { request } from "../api"

async function fetchBikeCondition(
  jobId: string,
): Promise<ServiceBikeCondition | null> {
  try {
    return await request<ServiceBikeCondition>({
      url: populateRoute(Route.SERVICE_BIKE__GET_CONDITION, jobId),
      method: "GET",
    })
  } catch (error) {
    console.error({ error })
    return null
  }
}

const bikeConditionQueries = {
  all: () => ["bike-condition"],
  details: () => [...bikeConditionQueries.all(), "detail"],
  detail: (jobId: string) =>
    queryOptions({
      queryKey: [...bikeConditionQueries.details(), jobId],
      queryFn: () => fetchBikeCondition(jobId),
    }),
}

export default bikeConditionQueries
